<template>
    <div :name="name" class="col-sm-12 timecard timecardDay">
        <div class="col-sm-2 timecard">
            <div :class="showProjectLocation ? 'col-sm-4' : 'col-sm-6'"><input class="form-control smaller" name="day_date" v-model="date.short" type="text" tabindex="-1" readonly/></div>
            <div :class="showProjectLocation ? 'col-sm-5' : 'col-sm-6'">
                <select class="smaller form-control" style="text-align: left" name="day_type" v-model="day_type" @change="updateDayType" required :disabled="inactiveEmployee">
                    <option 
                        v-for="daytype in filteredDayTypes"
                        :key="daytype.code"
                        :value="daytype.code"
                    >
                        {{daytype.name}}
                    </option>
                </select>
            </div>
            <div v-if="showProjectLocation" class="col-sm-3">
                <select class="form-control" name="location" v-model="location_id" @change="locationCheck" required>
                    <option value=""></option>
                    <option 
                        v-for="location in projectlocations"
                        :key="location.id"
                        :value="location.id"
                    >
                        {{ location.country_id > 2 ? `${location.city} (Foreign Country)` : `${location.state} - ${location.city} (${location.country})` }}
                    </option>
                </select>
            </div>
        </div>

        <div v-if="timecardLayout !== 'sagTODO'">
            <div v-if="showProjects" class="col-sm-1">
                <select class="smaller form-control" style="text-align: left" name="project_code" v-model="project_code" @change="updateProject" required>
                    <option value="">Select Project</option>
                    <option 
                        v-for="proj in projects"
                        :key="proj.id"
                        :value="proj.code"
                    >
                        {{ (proj.signatory_name ? `${proj.signatory_name} - ` : '') + proj.name }}
                    </option>
                </select>
            </div>
            <div v-if="showAccountString" class="col-sm-1" style="padding-right: 0px !important">
                <div class="timecard" v-for="(col,ind) in accountColumns" :key="ind">
                    <div :class="accountColumnSize">
                        <!-- To Do. we need to make more concise. v-model="week[day].account[col] can't not be used in vue3 syntax (3.1.0 version)"-->
                        <div v-if="col === 'account'">
                            <div v-if="enableProBooks">
                               <autocomplete :options="probooksAccounts" :name="col" v-model="week[day].account.account" :preselect="week[day].account.account" :display="'code'" @select="selectAccountCoding($event,col)" placeholder="Acct" :default-show="true" :highlight="-1">
                                    <template v-slot:item="option">
                                        <p><strong>{{ option.code + ' - ' + option.itemname }}</strong></p>
                                    </template>
                                </autocomplete>
                            </div>
                            <div v-else>
                                <input class="form-control" :name="col" type="text" v-model="week[day].account.account" placeholder="Acct" />
                            </div>
                        </div>
                        <div v-else-if="col === 'fringe'">
                            <div v-if="enableProBooks">
                               <autocomplete :options="probooksAccounts" :name="col" v-model="week[day].account.fringe" :preselect="week[day].account.fringe" :display="'code'" @select="selectAccountCoding($event,col)" :placeholder="upperFirstCharacter(col)" :default-show="true" :highlight="-1">
                                    <template v-slot:item="option">
                                        <p><strong>{{ option.code + ' - ' + option.itemname }}</strong></p>
                                    </template>
                                </autocomplete>
                            </div>
                            <div v-else>
                                <input class="form-control" :name="col" type="text" v-model="week[day].account.fringe" :placeholder="upperFirstCharacter(col)" />
                            </div>
                        </div>
                        <div v-else-if="col === 'series'">
                            <div v-if="enableProBooks">
                               <autocomplete :options="probooksSeries" :name="col" v-model="week[day].account.series" :preselect="week[day].account.series" :display="'code'" @select="selectAccountCoding($event,col)" :placeholder="upperFirstCharacter(col)" :default-show="true" :highlight="-1">
                                    <template v-slot:item="option">
                                        <p><strong>{{ option.code + ' - ' + option.itemname }}</strong></p>
                                    </template>
                                </autocomplete>
                            </div>
                            <div v-else>
                                <input class="form-control" :name="col" type="text" v-model="week[day].account.series" :placeholder="upperFirstCharacter(col)" />
                            </div>
                        </div>
                        <div v-else-if="col === 'location'">
                            <div v-if="enableProBooks">
                               <autocomplete :options="probooksLocations" :name="col" v-model="week[day].account.location" :preselect="week[day].account.location" :display="'code'" @select="selectAccountCoding($event,col)" :placeholder="upperFirstCharacter(col)" :default-show="true" :highlight="-1">
                                    <template v-slot:item="option">
                                        <p><strong>{{ option.code + ' - ' + option.itemname }}</strong></p>
                                    </template>
                                </autocomplete>
                            </div>
                            <div v-else>
                                <input class="form-control" :name="col" type="text" v-model="week[day].account.location" :placeholder="upperFirstCharacter(col)" />
                            </div>
                        </div>
                        <div v-else-if="col === 'set'">
                            <div v-if="enableProBooks">
                               <autocomplete :options="probooksSets" :name="col" v-model="week[day].account.set" :preselect="week[day].account.set" :display="'code'" @select="selectAccountCoding($event,col)" :placeholder="upperFirstCharacter(col)" :default-show="true" :highlight="-1">
                                    <template v-slot:item="option">
                                        <p><strong>{{ option.code + ' - ' + option.itemname }}</strong></p>
                                    </template>
                                </autocomplete>
                            </div>
                            <div v-else>
                                <input class="form-control" :name="col" type="text" v-model="week[day].account.set" :placeholder="upperFirstCharacter(col)" />
                            </div>
                        </div>
                        <div v-else-if="col === 'freeField'">
                            <div v-if="enableProBooks">
                               <autocomplete :options="probooksFreeFields" :name="col" v-model="week[day].account.freeField" :preselect="week[day].account.freeField" :display="'code'" @select="selectAccountCoding($event,col)" :placeholder="upperFirstCharacter(col)" :default-show="true" :highlight="-1">
                                    <template v-slot:item="option">
                                        <p><strong>{{ option.code + ' - ' + option.itemname }}</strong></p>
                                    </template>
                                </autocomplete>
                            </div>
                            <div v-else>
                                <input class="form-control" :name="col" type="text" v-model="week[day].account.freeField" :placeholder="upperFirstCharacter(col)" />
                            </div>
                        </div>
                        <div v-else-if="col === 'freeField2'">
                            <div v-if="enableProBooks">
                               <autocomplete :options="probooksFreeFields" :name="col" v-model="week[day].account.freeField2" :preselect="week[day].account.freeField2" :display="'code'" @select="selectAccountCoding($event,col)" :placeholder="upperFirstCharacter(col)" :default-show="true" :highlight="-1">
                                    <template v-slot:item="option">
                                        <p><strong>{{ option.code + ' - ' + option.itemname }}</strong></p>
                                    </template>
                                </autocomplete>
                            </div>
                            <div v-else>
                                <input class="form-control" :name="col" type="text" v-model="week[day].account.freeField2" :placeholder="upperFirstCharacter(col)" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div :class="(showAccountString || showProjects) ? 'col-sm-3 timecard' : 'col-sm-4 timecard'" style="padding-right: 0px !important">
                <div class="col-sm-12 timecard">
                    <div class="col-xs-2"><time-input ref="time1" class="form-control" :key="'time1' + lastUpdated" name="time_1" v-model:time="time_1" :date-full="date_full" :errors="timeErrors.time_1" @update="verifyDay" @error="emitError" type="text" :readonly="readonly || dayLocked || inactiveEmployee" :tzoffset="tzoffset"/></div>
                    <div class="col-xs-2"><time-input ref="time3" class="form-control" :key="'time3' + lastUpdated" name="time_3" v-model:time="time_3" :date-full="date_full" :errors="timeErrors.time_3" @update="verifyDay" @error="emitError" type="text" :readonly="readonly || dayLocked || inactiveEmployee" :tzoffset="tzoffset"/></div>
                    <div class="col-xs-2"><time-input ref="time4" class="form-control" :key="'time4' + lastUpdated" name="time_4" v-model:time="time_4" :date-full="date_full" :errors="timeErrors.time_4" @update="verifyDay" @error="emitError" type="text" :readonly="readonly || dayLocked || inactiveEmployee" :tzoffset="tzoffset"/></div>
                    <div class="col-xs-2"><time-input ref="time5" class="form-control" :key="'time5' + lastUpdated" name="time_5" v-model:time="time_5" :date-full="date_full" :errors="timeErrors.time_5" @update="verifyDay" @error="emitError" type="text" tabindex="-1" :readonly="readonly || dayLocked || inactiveEmployee" :tzoffset="tzoffset"/></div>
                    <div class="col-xs-2"><time-input ref="time6" class="form-control" :key="'time6' + lastUpdated" name="time_6" v-model:time="time_6" :date-full="date_full" :errors="timeErrors.time_6" @update="verifyDay" @error="emitError" type="text" tabindex="-1" :readonly="readonly || dayLocked || inactiveEmployee" :tzoffset="tzoffset"/></div>
                    <div class="col-xs-2"><time-input ref="time2" class="form-control" :key="'time2' + lastUpdated" name="time_2" v-model:time="time_2" :date-full="date_full" :errors="timeErrors.time_2" @update="verifyDay" @error="emitError" type="text" :readonly="readonly || dayLocked || inactiveEmployee" :tzoffset="tzoffset"/></div>
                </div>
            </div>

            <div :class="(showAccountString && showProjects) ? 'col-sm-4 timecard' : 'col-sm-5 timecard'" style="padding-right: 0px !important">
                <div v-if="union" class="timecard">
                    <div class="col-xs-3 timecard">
                    <div class="col-xs-6 timecard">
                        <div v-if="isCanada">
                            <select class="smaller form-control" style="text-align: left" name="union_ndb_grace" @change="checkUnionMeals" v-model="selected_ndb_grace">
                                <option value="null"></option>
                                <option value="ndb">NDB</option>
                                <option value="ndm1">NDM 1</option>
                                <option value="grace">Grace</option>
                            </select>
                        </div>
                        <div v-else>
                            <select class="smaller form-control" style="text-align: left" name="union_ndb_grace" @change="checkUnionMeals" v-model="selected_ndb_grace">
                                <option value="null"></option>
                                <option value="ndb">NDB</option>
                                <option value="grace">Grace</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-xs-6 timecard">
                        <select class="smaller form-control" style="text-align: left" name="union_wm_wrap" @change="checkUnionMeals" v-model="selected_wm_wrap">
                            <option value="null"></option>
                            <option value="wrap">Wrap</option>
                            <option value="wm">WM</option>
                        </select>
                    </div>
                    </div>
                    <div class="col-xs-1 timecard">
                        <div class="col-xs-6"><input class="form-control" name="meal_penalty_1" type="text" v-model="meal_penalty_1" tabindex="-1" readonly /></div>
                        <div class="col-xs-6"><input class="form-control" name="meal_penalty_2" type="text" v-model="meal_penalty_2" tabindex="-1" readonly /></div>
                    </div>
                    <div class="col-sm-7 timecard">
                        <div class="col-xs-6 timecard">
                            <div class="col-xs-4"><input class="form-control" name="hours_straight" v-model="hours_straight" type="text" tabindex="-1" readonly /></div>
                            <div class="col-xs-4"><input class="form-control" name="hours_ot1_5" v-model="hours_ot_15" type="text" tabindex="-1" readonly /></div>
                            <div class="col-xs-4"><input class="form-control" name="hours_ot_2" v-model="hours_ot_2" type="text" tabindex="-1" readonly /></div>
                        </div>
                        <div class="col-xs-6 timecard">
                            <div class="col-xs-3"><input class="form-control" name="hours_ot_25" v-model="hours_ot_25" type="text" tabindex="-1" readonly /></div>
                            <div class="col-xs-3"><input class="form-control" name="hours_ot_345" v-model="hours_ot_345" type="text" tabindex="-1" readonly /></div>
                            <div class="col-xs-3"><input class="form-control" name="hours_ot_gold" v-model="hours_ot_gold" type="text" tabindex="-1" readonly /></div>
                            <div class="col-xs-3"><input class="form-control" name="hours_forced" v-model="hours_forced" type="text" tabindex="-1" readonly /></div>
                        </div>
                    </div>
                    <div class="col-xs-1 timecard"><input class="form-control" name="hours_total" v-model="hours_total" type="text" tabindex="-1" readonly /></div>
                </div>
                <div v-else class="timecard">
                    <div class="col-xs-2 timecard">
                        <div class="col-xs-6"><input class="form-control" name="meal_penalty_1" type="text" v-model="meal_penalty_1" tabindex="-1" readonly /></div>
                        <div class="col-xs-6"><input class="form-control" name="meal_penalty_2" type="text" v-model="meal_penalty_2" tabindex="-1" readonly /></div>
                    </div>
                    <div class="col-sm-8 timecard">
                        <div class="col-xs-3"><input class="form-control" name="hours_straight" v-model="hours_straight" type="text" tabindex="-1" readonly /></div>
                        <div class="col-xs-3"><input class="form-control" name="hours_ot1_5" v-model="hours_ot_15" type="text" tabindex="-1" readonly /></div>
                        <div class="col-xs-3"><input class="form-control" name="hours_ot2" v-model="hours_ot_2" type="text" tabindex="-1" readonly /></div>
                        <div class="col-xs-3"><input class="form-control" name="hours_ot_other" v-model="hours_ot_other" type="text" tabindex="-1" readonly /></div>
                    </div>
                    <div class="col-xs-2 timecard"><input class="form-control" name="hours_total" v-model="hours_total" type="text" tabindex="-1" readonly /></div>
                </div>
            </div>

        </div>
        <div v-else>
            <div class="col-sm-6 timecard">
                <div class="col-sm-5 timecard">

                    <div class="col-xs-3"><time-input class="form-control" :key="'time9' + lastUpdated" name="time_9" v-model:time="time_9" :date-full="date_full" :errors="timeErrors.time_9" @update="verifyDay" type="text" :readonly="readonly || dayLocked || inactiveEmployee" :tzoffset="tzoffset"/></div>
                    <div class="col-xs-3"><time-input class="form-control" :key="'time10' + lastUpdated" name="time_10" v-model:time="time_10" :date-full="date_full" :errors="timeErrors.time_10" @update="verifyDay" type="text" :readonly="readonly || dayLocked || inactiveEmployee" :tzoffset="tzoffset"/></div>

                    <div class="col-xs-3"><time-input class="form-control" :key="'time1' + lastUpdated" name="time_1" v-model:time="time_1" :date-full="date_full" :errors="timeErrors.time_1" @update="verifyDay" type="text" :readonly="readonly || dayLocked || inactiveEmployee" :tzoffset="tzoffset"/></div>
                    <div class="col-xs-3"><time-input class="form-control" :key="'time2' + lastUpdated" name="time_3" v-model:time="time_3" :date-full="date_full" :errors="timeErrors.time_3" @update="verifyDay" type="text" :readonly="readonly || dayLocked || inactiveEmployee" :tzoffset="tzoffset"/></div>
                </div>
                <div class="col-sm-7 timecard">
                    <div class="col-xs-2"><time-input class="form-control" :key="'time3' + lastUpdated" name="time_4" v-model:time="time_4" :date-full="date_full" :errors="timeErrors.time_4" @update="verifyDay" type="text" :readonly="readonly || dayLocked || inactiveEmployee" :tzoffset="tzoffset"/></div>
                    <div class="col-xs-2"><time-input class="form-control" :key="'time4' + lastUpdated" name="time_5" v-model:time="time_5" :date-full="date_full" :errors="timeErrors.time_5" @update="verifyDay" type="text" tabindex="-1" :readonly="readonly || dayLocked || inactiveEmployee" :tzoffset="tzoffset"/></div>
                    <div class="col-xs-2"><time-input class="form-control" :key="'time5' + lastUpdated" name="time_6" v-model:time="time_6" :date-full="date_full" :errors="timeErrors.time_6" @update="verifyDay" type="text" tabindex="-1" :readonly="readonly || dayLocked || inactiveEmployee" :tzoffset="tzoffset"/></div>
                    <div class="col-xs-2"><time-input class="form-control" :key="'time6' + lastUpdated" name="time_2" v-model:time="time_2" :date-full="date_full" :errors="timeErrors.time_2" @update="verifyDay" type="text" :readonly="readonly || dayLocked || inactiveEmployee" :tzoffset="tzoffset"/></div>

                    <div class="col-xs-2"><time-input class="form-control" :key="'time11' + lastUpdated" name="time_11" v-model:time="time_11" :date-full="date_full" :errors="timeErrors.time_11" @update="verifyDay" type="text" :readonly="readonly || dayLocked || inactiveEmployee" :tzoffset="tzoffset"/></div>
                    <div class="col-xs-2"><time-input class="form-control" :key="'time12' + lastUpdated" name="time_12" v-model:time="time_12" :date-full="date_full" :errors="timeErrors.time_12" @update="verifyDay" type="text" :readonly="readonly || dayLocked || inactiveEmployee" :tzoffset="tzoffset"/></div>
                </div>
            </div>
            <div class="col-xs-3 timecard">
                <div class="col-xs-2">
                    <select class="smaller form-control timecard" style="text-align: left" name="union_ndb_grace" @change="checkUnionMeals" v-model="selected_ndb_grace">
                        <option value="null"></option>
                        <option value="ndb">NDB</option>
                        <option value="grace">Grace</option>
                    </select>
                </div>
                <div class="col-xs-1"><input class="form-control" name="meal_penalty_1" type="text" v-model="meal_penalty_1" tabindex="-1" readonly /></div>
                <div class="col-xs-1"><input class="form-control" name="meal_penalty_2" type="text" v-model="meal_penalty_2" tabindex="-1" readonly /></div>
                <div class="col-xs-2"><input class="form-control" name="hours_straight" v-model="hours_straight" type="text" tabindex="-1" readonly /></div>
                <div class="col-xs-2"><input class="form-control" name="hours_ot1_5" v-model="hours_ot_15" type="text" tabindex="-1" readonly /></div>
                <div class="col-xs-2"><input class="form-control" name="hours_ot_2" v-model="hours_ot_2" type="text" tabindex="-1" readonly /></div>
                <div class="col-xs-2"><input class="form-control" name="hours_total" v-model="hours_total" type="text" tabindex="-1" readonly /></div>
            </div>
        </div>


        <div class="col-sm-1">
            <slot name="copy">
                <a @click="inactiveEmployee ? false : duplicateYesterday()" data-toggle="tooltip" title="Duplicate Yesterday's Times" tabindex="-1"><span :class="(inactiveEmployee ? 'gray' : '') + ' glyphicon glyphicon-duplicate bigger p-left-5'" aria-hidden="true"></span></a>
            </slot>
            <a @click="showDetails=true" data-toggle="tooltip" title="View Details" tabindex="-1"><span class="glyphicon glyphicon-edit bigger p-sides-5" aria-hidden="true"></span></a>
            <a @click="clearDay" data-toggle="tooltip" title="Clear Today" tabindex="-1"><span class="red glyphicon glyphicon-remove bigger" aria-hidden="true"></span></a>
        </div>
        <div class="modalDialog is-active" v-show="showDetails" role="dialog" aria-labelledby="modal-title" aria-describedby="modal-description" aria-hidden="true" @keyup.esc="showDetails=false">
            <div class="modal-contents">
                <div>
                    <a title="Close" class="close" @click="showDetails=false">X</a>
                    <h3 id="modal-title">Details</h3>
                    <hr />
                </div>
                <div>
                    <div class="col-sm-3"><label for="assignment">Assignment</label></div>
                    <div class="col-sm-9">
                        <select class="form-control" name="assignment" v-model="assignment_id" @change="updateAssignment" required>
                            <option 
                                v-for="assignment in assignments"
                                :key="assignment.id"
                                :value="assignment.id"
                            >
                                {{assignment.job_title_override}}
                            </option>
                        </select>
                    </div>
                    <div class="col-sm-3"><label for="location">Location</label></div>
                    <div class="col-sm-9">
                        <select class="form-control" name="location" v-model="location_id" @change="locationCheck" required>
                            <option 
                                v-for="location in projectlocations"
                                :key="location.id"
                                :value="location.id"
                            >
                                {{location.name}}
                            </option>
                        </select>
                    </div>
                    <div v-if="union">
                        <div class="col-sm-3"><label for="union_local_id">Studio/Distant</label></div>
                        <div class="col-sm-9">
                            <select class="form-control" name="union_location" v-model="union_location_id" @change="updateUnionLocationDay" :readonly="readonly || dayLocked" :disabled="dayLocked" title="">
                                <option value="">Use Default Location</option>
                                <option 
                                    v-for="location in unionlocations"
                                    :key="location.id"
                                    :value="location.id"
                                >
                                    {{ location.name }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="col-sm-3"><label for="job_title_override">Title Override</label></div>
                    <div class="col-sm-9"><input class="form-control" type="text" name="job_title_override" v-model="job_title_override" @change="updateJobTitle" placeholder="" tabindex="-1" :readonly="type == 'employee'"></div>
                    <div class="col-sm-3"><label for="rate">Rate</label></div>
                    <div class="col-sm-9"><input class="form-control" name="rate" v-model="rate" @change="updateRate" type="text" placeholder="Value must match base rate unit(Hourly/Daily/Weekly)" :readonly="type == 'employee'"/></div>
                    <div v-if="type == 'employer'" class="col-sm-3 m-top-10"><label for="employer_comments">Employer Comments</label></div>
                    <div v-if="type == 'employer'" class="col-sm-9 m-top-10 m-bottom-10"><textarea class="form-control" name="employer_comments" rows="6" v-model="employer_comments" @change="updateErComment" placeholder="" :readonly="type == 'employee'"></textarea></div>
                    <div class="col-sm-3 m-top-10"><label for="employee_comments">Employee Comments</label></div>
                    <div class="col-sm-9 m-top-10 m-bottom-10"><textarea class="form-control" name="employee_comments" rows="6" v-model="employee_comments" @change="updateEeComment" placeholder="" :readonly="type == 'employer'"></textarea></div>
                    <div class="clear"></div>
                    <hr />
                </div>
                <div class="right">
                    <span class="btn btn-default m-right-10" @click="showDetails=false">Cancel</span>
                    <span class="btn btn-primary" @click="showDetails=false">OK</span>
                </div>
                <div class="clear"></div>
            </div>
        </div>
    </div>
</template>
<script>
import autocomplete from '../components/autocomplete.vue';
import timeInput from '../components/timeInput.vue';
import timecardDetails from '../components/timecardDetails.vue';
import TimecardMixin from '../mixins/TimecardMixin';
import UtilitiesMixin from '../mixins/UtilitiesMixin';
import dateFormatUtilMixin from '../mixins/DateFormatUtil';
import COAMixin from '../mixins/COAMixin'
import {defineComponent} from 'vue';

export default defineComponent ({
    emits: ['error', 'modified', 'accrual', 'clicked'],

    components: {
      autocomplete,
      timeInput,
      timecardDetails
    },

    mixins: [ TimecardMixin, UtilitiesMixin, COAMixin, dateFormatUtilMixin ],

    props: {
        enableProBooks: {
            type: Boolean,
            required: false,
            default: false,
        },
        probooksAccounts: {
            type: [ Array, String ],
            required: false,
        },
        probooksFreeFields: {
            type: [ Array, String ],
            required: false,
        },
        probooksSeries: {
            type: [ Array, String ],
            required: false,
        },
        probooksLocations: {
            type: [ Array, String ],
            required: false,
        },
        probooksSets: {
            type: [ Array, String ],
            required: false,
        },
        probooksProjects: {
            type: [ Array, String ],
            required: false,
        },
        prepStartDay: {
            type: String,
            default: ''
        },
        prepEndDay: {
            type: String,
            default: ''
        },
        wrapStartDay: {
            type: String,
            default: ''
        },
        wrapEndDay: {
            type: String,
            default: ''
        },
        isNew: {
            type: Boolean,
            default: false
        },
        name: {
            type: String,
            required: true
        },
        date: {
            type: Object,
            required: true
        },
        week: {
            type: Object,
            required: false
        },
        day: {
            type: String,
            required: true,
        },
        dayType: {
            type: String,
            required: false,
            default: 'nowork'
        },
        tcdata: {
            type: Object,
            required: false
        },
        assignments: {
            type: Array,
            required: false
        },
        baserate: {
            type: Object,
            required: false
        },
        union: {
            type: Boolean,
            required: false
        },
        projectlocations: {
            type: Array,
            required: false
        },
        showProjectLocation: {
            type: Boolean,
            required: false,
            default: false,
        },
        unionlocations: {
            type: Array,
            required: false
        },
        unionloc: {
            type: [ String, Number ],
            required: false
        },
        daytypes: {
            type: Array,
            required: false
        },
        jobtitles: {
            type: Array,
            required: false
        },
        titleor: {
            type: String,
            required: false
        },
        mainassignment: {
            required: false
        },
        mainlocation: {
            required: false
        },
        locationChanged: {
            required: true,
            type: Boolean,
        },
        broken: {
            type: Object,
            required: false
        },
        type: {
            type: String,
            required: true
        },
        project: {
            type: String,
            required: false,
            default: ''
        },
        projects: {
            type: Array,
            required: false
        },
        showProjects: {
            type: Boolean,
            default: false,
            required: false
        },
        showAssignedProjects: {
            type: Boolean,
            default: false,
            required: false
        },
        showAccountString: {
            type: Boolean,
            default: false,
            required: false
        },
        accountString: {
            type: Object,
            default: () => {},
            required: false
        },
        defaultAccount: {
            type: String,
            required: false
        },
        defaultFringe: {
            type: String,
            required: false
        },
        defaultSeries: {
            type: String,
            required: false
        },
        defaultLocation: {
            type: String,
            required: false
        },
        defaultSet: {
            type: String,
            required: false
        },
        defaultFreeField: {
            type: String,
            required: false
        },
        defaultFreeField2: {
            type: String,
            required: false
        },
        tzoffset: {
            type: Number,
            required: false
        },
        timeImport: {
            type: Object,
            required: false
        },
        timecardLayout: {
            type: String,
            required: false
        },
        termDate: {
            type: String,
            required: false
        },
        startDate: {
            type: String,
            required: false
        },
        readonly: {
            type: Boolean,
            default: false,
            required: false
        },
        previous_last_day: {
            type: Object,
            default: () => {},
            required: false
        },
        isCanada: {
            type: Boolean,
            default: false,
            required: false
        },
    },

    data() {
        return {
            ppStartDay: '',
            ppEndDay: '',
            wpStartDay: '',
            wpEndDay: '',
            selected_ndb_grace: null,
            selected_wm_wrap: null,
            lastUpdated: '',
            showDetails: false,
            day_comments: '',
            dayLocked: false,
            time_1: '',
            time_2: '',
            time_3: '',
            time_4: '',
            time_5: '',
            time_6: '',
            time_7: '',
            time_8: '',
            time_9: '',
            time_10: '',
            time_11: '',
            time_12: '',
            rate: '',
            rate_unit_id: '',
            assignment: '',
            assignment_id: '',
            day_type: this.dayType,
            filteredDayTypes: [],
            project_code: '',
            location: '',
            location_id: '',
            union_location: '',
            union_location_id: '',
            job_title_override: '',
            employee_comments: '',
            employer_comments: '',
            timeErrors: {
                time_1: false,
                time_2: false,
                time_3: false,
                time_4: false,
                time_5: false,
                time_6: false,
                time_7: false,
                time_8: false,
                time_9: false,
                time_10: false,
                time_11: false,
                time_12: false,
            },
        }
    },

    computed: {
        format() {
            return this.getDateFormat();
        },
        currentAssignment() {
            if (!this.assignments) return null
            return this.assignments.find(({id}) => parseInt(id) === parseInt(this.mainassignment)) || null;
        },
        isExempt() {
            return (this.currentAssignment && parseInt(this.currentAssignment.flsa_type_id) === 2);
        },
        date_full() { return this.date.full },
        inactiveEmployee() {
            if (!this.date) return false;

            let isInactive = false;
            let currentDate = new Date(this.date.full);
            currentDate.setHours(0, 0)

            if (this.termDate) {
                const terminationDate = new Date(this.termDate);

                if (currentDate > terminationDate) {
                    isInactive = true;
                }
            }

            if (this.startDate) {
                const startDate = new Date(this.startDate);

                if (currentDate < startDate) {
                    isInactive = true;
                }
            }

            if (isInactive) {
                if (this.time_1 || this.time_2 || this.time_3 || this.time_4 || this.time_5 || this.time_6) {
                    isInactive = false;
                    return false;
                }
                this.day_type = 'unpaid';
                this.week[this.day].day_type = 'unpaid';
                return true;
            }
            else {
                return false;
            }
            
        },
        meal_penalty_1() {
            if (! this.broken.penalty_meal_1 || isNaN(this.broken.penalty_meal_1.value)) {
                return 0;
            } else {
                return (this.broken.penalty_meal_1.value);
            }
        },
        meal_penalty_2() {
            if (! this.broken.penalty_meal_2 || isNaN(this.broken.penalty_meal_2.value)) {
                return 0;
            } else {
                return (this.broken.penalty_meal_2.value);
            }
        },
        hours_straight() {
            const buckets = [ 'pay_straight', 'pay_straight_other', 'pay_straight_other2' ];
            let hours = 0;
            for (const b of buckets) {
                hours += (this.broken[b] && !isNaN(this.broken[b].hours)) ? this.broken[b].hours : 0
            }
            return hours.toFixed(2);
        },
        hours_ot_15() {
            if (! this.broken.pay_ot_15 || isNaN(this.broken.pay_ot_15.hours)) {
                return 0.00;
            } else {
                return ((this.broken.pay_ot_15 || {}).hours || 0).toFixed(2);
            }
        },
        hours_ot_2() {
            const buckets = [ 'pay_ot_2', 'pay_ot_2_other' ];
            let hours = 0;
            for (const b of buckets) {
                hours += (this.broken[b] && !isNaN(this.broken[b].hours)) ? this.broken[b].hours : 0
            }
            return hours.toFixed(2);
        },
        hours_ot_25() {
            const buckets = [ 'pay_ot_25', 'pay_ot_25_other' ];
            let hours = 0;
            for (const b of buckets) {
                hours += (this.broken[b] && !isNaN(this.broken[b].hours)) ? this.broken[b].hours : 0
            }
            return hours.toFixed(2);
        },
        hours_ot_3() {
            const buckets = [ 'pay_ot_3', 'pay_ot_3_other' ];
            let hours = 0;
            for (const b of buckets) {
                hours += (this.broken[b] && !isNaN(this.broken[b].hours)) ? this.broken[b].hours : 0
            }
            return hours.toFixed(2);
        },
        hours_ot_4() {
            if (! this.broken.pay_ot_4 || isNaN(this.broken.pay_ot_4.hours)) {
                return 0.00;
            } else {
                return ((this.broken.pay_ot_4 || {}).hours || 0).toFixed(2);
            }
        },
        hours_ot_5() {
            if (! this.broken.pay_ot_5 || isNaN(this.broken.pay_ot_5.hours)) {
                return 0.00;
            } else {
                return ((this.broken.pay_ot_5 || {}).hours || 0).toFixed(2);
            }
        },
        hours_ot_15_gold() {
            if (! this.broken.pay_ot_15_gold || isNaN(this.broken.pay_ot_15_gold.hours)) {
                return 0.00;
            } else {
                return ((this.broken.pay_ot_15_gold || {}).hours || 0).toFixed(2);
            }
        },
        hours_ot_2_gold() {
            const buckets = [ 'pay_ot_2_gold', 'pay_ot_2_other_gold' ];
            let hours = 0;
            for (const b of buckets) {
                hours += (this.broken[b] && !isNaN(this.broken[b].hours)) ? this.broken[b].hours : 0
            }
            return hours.toFixed(2);
        },
        hours_ot_3_gold() {
            if (! this.broken.pay_ot_3_gold || isNaN(this.broken.pay_ot_3_gold.hours)) {
                return 0.00;
            } else {
                return ((this.broken.pay_ot_3_gold || {}).hours || 0).toFixed(2);
            }
        },
        hours_ot_4_gold() {
            if (! this.broken.pay_ot_4_gold || isNaN(this.broken.pay_ot_4_gold.hours)) {
                return 0.00;
            } else {
                return ((this.broken.pay_ot_4_gold || {}).hours || 0).toFixed(2);
            }
        },
        hours_ot_5_gold() {
            if (! this.broken.pay_ot_5_gold || isNaN(this.broken.pay_ot_5_gold.hours)) {
                return 0.00;
            } else {
                return ((this.broken.pay_ot_5_gold || {}).hours || 0).toFixed(2);
            }
        },
        hours_straight_forced() {
            if (! this.broken.pay_straight_forced || isNaN(this.broken.pay_straight_forced.hours)) {
                return 0.00;
            } else {
                return ((this.broken.pay_straight_forced || {}).hours || 0).toFixed(2);
            }
        },
        hours_ot_15_forced() {
            if (! this.broken.pay_ot_15_forced || isNaN(this.broken.pay_ot_15_forced.hours)) {
                return 0.00;
            } else {
                return ((this.broken.pay_ot_15_forced || {}).hours || 0).toFixed(2);
            }
        },
        hours_ot_2_forced() {
            const buckets = [ 'pay_ot_2_forced', 'pay_ot_2_other_forced' ];
            let hours = 0;
            for (const b of buckets) {
                hours += (this.broken[b] && !isNaN(this.broken[b].hours)) ? this.broken[b].hours : 0
            }
            return hours.toFixed(2);
        },
        hours_ot_3_forced() {
            if (! this.broken.pay_ot_3_forced || isNaN(this.broken.pay_ot_3_forced.hours)) {
                return 0.00;
            } else {
                return ((this.broken.pay_ot_3_forced || {}).hours || 0).toFixed(2);
            }
        },
        hours_ot_4_forced() {
            if (! this.broken.pay_ot_4_forced || isNaN(this.broken.pay_ot_4_forced.hours)) {
                return 0.00;
            } else {
                return ((this.broken.pay_ot_4_forced || {}).hours || 0).toFixed(2);
            }
        },
        hours_ot_5_forced() {
            if (! this.broken.pay_ot_5_forced || isNaN(this.broken.pay_ot_5_gold.hours)) {
                return 0.00;
            } else {
                return ((this.broken.pay_ot_5_forced || {}).hours || 0).toFixed(2);
            }
        },
        hours_ot_15_gold_forced() {
            if (! this.broken.pay_ot_15_gold_forced || isNaN(this.broken.pay_ot_15_gold_forced.hours)) {
                return 0.00;
            } else {
                return ((this.broken.pay_ot_15_gold_forced || {}).hours || 0).toFixed(2);
            }
        },
        hours_ot_2_gold_forced() {
            if (! this.broken.pay_ot_2_gold_forced || isNaN(this.broken.pay_ot_2_gold_forced.hours)) {
                return 0.00;
            } else {
                return ((this.broken.pay_ot_2_gold_forced || {}).hours || 0).toFixed(2);
            }
        },
        hours_ot_3_gold_forced() {
            if (! this.broken.pay_ot_3_gold_forced || isNaN(this.broken.pay_ot_3_gold_forced.hours)) {
                return 0.00;
            } else {
                return ((this.broken.pay_ot_3_gold_forced || {}).hours || 0).toFixed(2);
            }
        },
        hours_ot_4_gold_forced() {
            if (! this.broken.pay_ot_4_gold_forced || isNaN(this.broken.pay_ot_4_gold_forced.hours)) {
                return 0.00;
            } else {
                return ((this.broken.pay_ot_4_gold_forced || {}).hours || 0).toFixed(2);
            }
        },
        hours_ot_5_gold_forced() {
            if (! this.broken.pay_ot_5_gold_forced || isNaN(this.broken.pay_ot_5_gold_forced.hours)) {
                return 0.00;
            } else {
                return ((this.broken.pay_ot_5_gold_forced || {}).hours || 0).toFixed(2);
            }
        },
        hours_ot_gold() {
            let hours = 0;
            let gold = Object.keys(this.broken).filter(val => {
                return val.match(/^pay_.*gold$/);
            });

            if (!gold.length) return hours;

            for (let i of gold) {
                hours += this.broken[i].hours || 0;
            }

            return hours.toFixed(2);
        },
        hours_forced() {
            let hours = 0;
            let forced = Object.keys(this.broken).filter(val => {
                return val.match(/^pay_.*forced$/);
            });

            if (!forced.length) return hours;

            for (let i of forced) {
                hours += this.broken[i].hours || 0;
            }

            return hours.toFixed(2);
        },
        multiplier_forced() {
            let forced = Object.keys(this.broken).filter(val => {
                return val.match(/^pay_.*forced$/);
            });

            if (!forced.length) return 0;

            return this.broken[forced[0]].actionValue || 0;
        },
        hours_ot_other() {
            let hours = 0.00;
            let countedOt = [
                'pay_ot_15', 'pay_ot_2', 'pay_ot_2_other', 'pay_ot_25', 'pay_ot_25_other', 'pay_ot_3', 'pay_ot_4', 'pay_ot_5',
                'pay_ot_15_gold', 'pay_ot_2_gold', 'pay_ot_2_other_gold', 'pay_ot_25_gold', 'pay_ot_25_other_gold', 'pay_ot_3_gold', 'pay_ot_3_other_gold', 'pay_ot_4_gold', 'pay_ot_5_gold',
                'pay_ot_15_forced', 'pay_ot_2_forced', 'pay_ot_2_other_forced', 'pay_ot_25_forced', 'pay_ot_25_other_forced', 'pay_ot_3_forced', 'pay_ot_3_other_forced', 'pay_ot_4_forced', 'pay_ot_5_forced',
                'pay_ot_15_gold_forced', 'pay_ot_2_gold_forced', 'pay_ot_25_gold_forced', 'pay_ot_3_gold_forced', 'pay_ot_4_gold_forced', 'pay_ot_5_gold_forced',
            ];
            let otherOt = Object.keys(this.broken).filter(val => {
                return val.match(/^pay_ot/) && countedOt.indexOf(val) < 0;
            });

            if (!otherOt.length) return hours;

            for (let i of otherOt) {
                hours += this.broken[i].hours || 0;
            }

            return hours.toFixed(2);
        },
        hours_ot_other_emp() {
            let hours = 0.00;
            let countedOt = [ 'pay_ot_15', 'pay_ot_2', 'pay_ot_2_other' ];
            let otherOt = Object.keys(this.broken).filter(val => {
                return val.match(/^pay_ot/) && countedOt.indexOf(val) < 0;
            });

            if (!otherOt.length) return hours;

            for (let i of otherOt) {
                hours += this.broken[i].hours || 0;
            }

            return hours.toFixed(2);
        },
        hours_ot_2_forced_total () {
            return (parseFloat(this.hours_ot_2_gold_forced) + parseFloat(this.hours_ot_2_forced) + parseFloat(this.hours_ot_2_other_forced)).toFixed(2);
        },
        hours_ot_345_forced_total () {
            return (parseFloat(this.hours_ot_345_gold_forced) + parseFloat(this.hours_ot_345_forced)).toFixed(2);
        },
        hours_ot_345 () {
            return (parseFloat(this.hours_ot_3) + parseFloat(this.hours_ot_4) + parseFloat(this.hours_ot_5)).toFixed(2);
        },
        hours_ot_345_gold () {
            return (parseFloat(this.hours_ot_3_gold) + parseFloat(this.hours_ot_4_gold) + parseFloat(this.hours_ot_5_gold)).toFixed(2);
        },
        hours_ot_345_forced () {
            return (parseFloat(this.hours_ot_3_forced) + parseFloat(this.hours_ot_4_forced) + parseFloat(this.hours_ot_5_forced)).toFixed(2);
        },
        hours_ot_345_gold_forced () {
            return (parseFloat(this.hours_ot_3_gold_forced) + parseFloat(this.hours_ot_4_gold_forced) + parseFloat(this.hours_ot_5_gold_forced) ).toFixed(2);
        },
        hours_idle() {
            if (! this.broken.pay_idle || isNaN(this.broken.pay_idle.hours)) {
                return 0.00;
            } else {
                return ((this.broken.pay_idle || {}).hours || 0).toFixed(2);
            }
        },
        hours_holiday() {
            let hours = 0;
            let holiday = Object.keys(this.broken).filter(val => {
                return val.match(/^pay_holiday/);
            });

            if (!holiday.length) return hours;

            for (let i of holiday) {
                hours += this.broken[i].hours || 0;
            }

            return hours.toFixed(2);
        },
        hours_travel() {
            if (! this.broken.pay_travel || isNaN(this.broken.pay_travel.hours)) {
                return 0.00;
            } else {
                return ((this.broken.pay_travel || {}).hours || 0).toFixed(2);
            }
        },
        hours_total() {
            if (! this.broken.total || isNaN(this.broken.total.hours)) {
                return '';
            } else {
                return ((this.broken.total || {}).hours || 0).toFixed(2);
            }
            // return (this.hours_straight*1 + this.hours_ot_15*1 + this.hours_ot_2*1).toFixed(2);
        },
        non_standard_ot() {
            let payroll = [];
            let countedOt = [ 'pay_ot_15', 'pay_ot_2' ];
            let otherOt = Object.keys(this.broken).filter(val => {
                return val.match(/^pay_ot/) && countedOt.indexOf(val) < 0;
            });

            if (!otherOt.length) return [];

            for (let i of otherOt) {
                let label;
                const parts = i.split('_');
                if (parts[1].toLowerCase() !== 'ot') continue;

                switch (parts[3]) {
                    case undefined:
                        label = (parts[2] === '15' ? 1.5 : parts[2]) + ' OT';
                        break;

                    case 'gold':
                        if (parts[4] && parts[4] === 'forced') {
                            label = (parts[2] === '15' ? 1.5 : parts[2]) + ' G';
                        } else {
                            label = (parts[2] === '15' ? 1.5 : parts[2]) + ' FG';
                        }
                        break;

                    case 'forced':
                        label = (parts[2] === '15' ? 1.5 : parts[2]) + ' FC';
                        break;

                    default:
                        label = (parts[2] === '15' ? 1.5 : parts[2]) + ' OT';
                }
                
                payroll.push({ name: label, pay: this.broken[i].pay, hours: this.broken[i].hours } || {});
            }

            const sorted = this.sortObjectByProperty(payroll, 'label');
            // console.log(sorted);
            return sorted;
        },

        imported_time_1 () {
            return (this.timeImport || {}).time_1;
        },

        accountColumns () {
            let columns = [];
            for (let label in this.accountString) {
                if (this.accountString[label] === true) {
                    columns.push(label)
                }
            }
            return columns;
        },

        accountColumnSize (last=false) {
            const fields = this.accountColumns.length || 1;
            const colsize = Math.floor(12 / fields);
            let colstring = ''

            if (last) colstring = 'col-xs-' + (12 % fields === 0 ? colsize : 12 % fields);
            else colstring = 'col-xs-' + colsize;

            return colstring;
        },
    },

    watch: {
        prepStartDay(newValue) {
            this.ppStartDay = newValue;
        },
        prepEndDay(newValue) {
            this.ppEndDay = newValue;
        },
        wrapStartDay(newValue) {
            this.wpStartDay = newValue;
        },
        wrapEndDay(newValue) {
            this.wpEndDay = newValue;
        },
        tcdata(newValue) {
            this.loadDay(newValue);
            if (this.week[this.day].union_location_id) {
                this.updateUnionLocationDay(this.week[this.day].union_location_id);
            }
        },
        titleor (newValue) {
            if (newValue && ! this.job_title_override) this.job_title_override = newValue;
        },
        mainassignment (newValue) {
            if (newValue && ! this.assignment_id) this.assignment_id = newValue;
        },
        mainlocation (newValue, oldValue) {
            // Set the default location id
            let actual_location_id = parseInt(this.week[this.day].location_id);
            if (newValue && newValue !== oldValue && !actual_location_id) {
                this.location_id = parseInt(newValue);
            }
        },
        // Override if main location is changed
        locationChanged (newValue) {
            if (newValue === true) {
                this.week[this.day].location_id = this.location_id = parseInt(newValue);
            }
        },
        baserate (newValue) {
            if (! isNaN(newValue.rate) && (! this.rate || isNaN(this.rate))) this.rate = newValue.rate;
        },
        daytypes (newValue) {
            if (newValue) this.filteredDayTypes = newValue;
        },
        imported_time_1 (newValue) {
            this.loadTimes(this.timeImport);
        },
        defaultAccount() {
            if (typeof this.week[this.day].account === 'undefined') {
                this.week[this.day].account = { account: this.defaultAccount, fringe: undefined, series: undefined, location: undefined, set: undefined, freeField: undefined, freeField2: undefined };
            }
            if (this.isNew || this.week[this.day].account.account === undefined || !this.showAccountString || !this.accountString.account) {
                this.week[this.day].account.account = this.defaultAccount;
            }
        },
        defaultFringe() {
            if (typeof this.week[this.day].account === 'undefined') {
                this.week[this.day].account = { account: undefined, fringe: this.defaultFringe, series: undefined, location: undefined, set: undefined, freeField: undefined, freeField2: undefined };
            }
            if (this.isNew || this.week[this.day].account.fringe === undefined || !this.showAccountString || !this.accountString.fringe) {
                this.week[this.day].account.fringe = this.defaultFringe;
            }
        },
        defaultSeries() {
            if (typeof this.week[this.day].account === 'undefined') {
                this.week[this.day].account = { account: undefined, fringe: undefined, series: this.defaultSeries, location: undefined, set: undefined, freeField: undefined, freeField2: undefined };
            }
            if (this.isNew || this.week[this.day].account.series === undefined || !this.showAccountString || !this.accountString.series) {
                this.week[this.day].account.series = this.defaultSeries;
            }
        },
        defaultLocation() {
            if (typeof this.week[this.day].account === 'undefined') {
                this.week[this.day].account = { account: undefined, fringe: undefined, series: undefined, location: this.defaultLocation, set: undefined, freeField: undefined, freeField2: undefined };
            }
            if (this.isNew || this.week[this.day].account.location === undefined || !this.showAccountString || !this.accountString.location) {
                this.week[this.day].account.location = this.defaultLocation;
            }
        },
        defaultSet() {
            if (typeof this.week[this.day].account === 'undefined') {
                this.week[this.day].account = { account: undefined, fringe: undefined, series: undefined, location: undefined, set: this.defaultSet, freeField: undefined, freeField2: undefined };
            }
            if (this.isNew || this.week[this.day].account.set === undefined || !this.showAccountString || !this.accountString.set) {
                this.week[this.day].account.set = this.defaultSet;
            }
        },
        defaultFreeField() {
            if (typeof this.week[this.day].account === 'undefined') {
                this.week[this.day].account = { account: undefined, fringe: undefined, series: undefined, location: undefined, set: undefined, freeField: this.defaultFreeField, freeField2: undefined };
            } 
            if (this.isNew || this.week[this.day].account.freeField === undefined || !this.showAccountString || !this.accountString.freeField) {
                this.week[this.day].account.freeField = this.defaultFreeField;
            }
        },
        defaultFreeField2() {
            if (typeof this.week[this.day].account === 'undefined') {
                this.week[this.day].account = { account: undefined, fringe: undefined, series: undefined, location: undefined, set: undefined, freeField: undefined, freeField2: this.defaultFreeField2 };
            } 
            if (this.isNew || this.week[this.day].account.freeField2 === undefined || !this.showAccountString || !this.accountString.freeField2) {
                this.week[this.day].account.freeField2 = this.defaultFreeField2;
            }
        },
    },

    methods: {
        selectAccountCoding(selectedData,col) {
            let updateValue = '';
            if (selectedData && selectedData.code) updateValue = selectedData.code;

            if (col === 'account') {
                this.week[this.day].account.account = updateValue;

                if (this.accountString && this.accountString.fringe) {
                    if (updateValue) {
                        const setFringe = updateValue.substring(0,updateValue.length-2) + '99';
                        let validate = this.probooksAccounts.findIndex((el) => { return el.code == setFringe });
                        if (validate == -1) {
                            this.week[this.day].account.fringe = '';
                        } else {
                            this.week[this.day].account.fringe = setFringe;
                        }
                    } else {
                        this.week[this.day].account.fringe = '';
                    }
                }
            } else if (col === 'fringe') {
                this.week[this.day].account.fringe = updateValue;
            } else if (col === 'series') {
                this.week[this.day].account.series = updateValue;
            } else if (col === 'set') {
                this.week[this.day].account.set = updateValue;
            } else if (col === 'location') {
                this.week[this.day].account.location = updateValue;
            } else if (col === 'freeField') {
                this.week[this.day].account.freeField = updateValue;
            } else if (col === 'freeField2') {
                this.week[this.day].account.freeField2 = updateValue;
            }
            this.$emit('modified', true);

            return;
        },
        checkUnionMeals() {
            if (this.selected_ndb_grace == 'ndb') {
                this.week[this.day].union_ndb = true;
                this.week[this.day].union_grace = false;
                this.week[this.day].union_ndm1 = false;
            } else if (this.selected_ndb_grace == 'ndm1') {
                this.week[this.day].union_ndb = false;
                this.week[this.day].union_grace = false;
                this.week[this.day].union_ndm1 = true;
            } else if (this.selected_ndb_grace == 'grace') {
                this.week[this.day].union_ndb = false;
                this.week[this.day].union_grace = true;
                this.week[this.day].union_ndm1 = false;
            } else {
                this.week[this.day].union_ndb = false;
                this.week[this.day].union_grace = false;
                this.week[this.day].union_ndm1 = false;
            }

            if (this.selected_wm_wrap == 'wm') {
                this.week[this.day].union_walking_meal = true;
                this.week[this.day].union_wrap = false;
            } else if (this.selected_wm_wrap == 'wrap') {
                this.week[this.day].union_walking_meal = false;
                this.week[this.day].union_wrap = true;
            } else {
                this.week[this.day].union_walking_meal = false;
                this.week[this.day].union_wrap = false;
            }
        },
        closeModal() { this.showDetails = false; },

        updateDayType( event ) {
            if (! this.titleor) {
                alert ("Please select an employee first");
                return false;
            }
            let target = event.target;
            if (! target) {
                return false;
            }

            if (this.day_type === 'sick' || this.day_type === 'covid_sick' || this.day_type === 'covid_fmla' || this.day_type === 'vacation' || this.day_type === 'nowork' || this.day_type === 'nw-holiday' || this.day_type === 'nw-paid' || this.day_type === 'stat-nw-holiday') {
                this.clearDay(this.day_type);
                this.dayLocked = true;
                this.day_type = target.value;
            } else {
                this.dayLocked = false;
            }
            this.week[this.day].day_type = target.value;

            if (this.day_type === 'sick' || this.day_type === 'covid_sick' || this.day_type === 'covid_fmla' || this.day_type === 'vacation') this.$emit('accrual', this.day_type);
            // else if (this.isExempt && this.day_type === 'nowork') this.$emit('error', 'TIP: This is an exempt employee. If you wish to not pay a week day, please select "Unpaid Day" for each date not worked.')
            else if (this.isExempt && parseInt(this.currentAssignment.rule_collection_id || 0) === 3 && (this.day === 'day_1' || this.day === 'day_7') && this.day_type === 'worked') this.$emit('error', 'TIP: This is an exempt employee. If you wish to pay for weekend work, please select "Bonus Day" for each weekend date worked.')

            this.$emit('modified', true);
            return true;
        },

        updateProject({ target }) {
            if (!target || !target.value) {
                return;
            }

            const project = this.projects.find((p) => p.code == target.value);
            if (project) {
                // Check if in bounds when using assigned projects
                if (this.showAssignedProjects) {
                    if (project.date_start && this.date.full < new Date(project.date_start.replace(/-/g, '/'))) {
                        this.project_code = '';
                        this.$emit('error', 'This project has not been assigned for this date.  Please use a different project or a date starting ' + project.date_start + ' or later.');
                        return;
                    }
                    if (project.date_end && this.date.full > new Date(project.date_end.replace(/-/g, '/'))) {
                        this.project_code = '';
                        this.$emit('error', 'This project has not been assigned for this date.  Please use a different project or a date ending ' + project.date_end + ' or earlier.');
                        return;
                    }
                }

                // Safe to update the project_id
                this.week[this.day].project_id = project.id;
            }
            // If here, update the project value
            this.week[this.day].project = target.value;
            this.$emit('modified', true);
            return;
        },

        updateAssignment( {target} ) {
            if (! target) {
                return false;
            }

            let selected = this.assignments.find(( {id}) => { return (id == target.value) });
            let er_comments = (this.employer_comments) ? this.employer_comments + "\n" : '';
            let ee_comments = (this.employee_comments) ? this.employee_comments + "\n" : '';

            this.assignment_id = selected.id;
            this.job_title_override = selected.job_title_override;
            this.rate = selected.hourly_rate;
            this.rate_unit_id = 1; // Always use hourly rate
            if (type === 'employer') {
                this.employer_comments = er_comments + "Changed Job/Rate to " + selected.job_title_override + ' (' + selected.hourly_rate + ').';
            } else if (type === 'employee') {
                this.employee_comments = ee_comments + "Changed Job/Rate to " + selected.job_title_override + ' (' + selected.hourly_rate + ').';
            }

            this.week[this.day].assignment_id = selected.id;
            this.week[this.day].job_title_override = selected.job_title_override;
            this.week[this.day].rate = selected.hourly_rate;
            this.week[this.day].rate_unit_id = 1;
            if (type === 'employer') {
                this.week[this.day].employer_comments = er_comments + "Changed Job/Rate to " + selected.job_title_override + ' (' + selected.hourly_rate + ').';
            } else if (type === 'employee') {
                this.week[this.day].employee_comments = ee_comments + "Changed Job/Rate to " + selected.job_title_override + ' (' + selected.hourly_rate + ').';
            }
            
            // Set default account/free
            if (this.showAccountString) {
                if (typeof this.week[this.day].account === 'undefined' || !this.week[this.day].account.hasOwnProperty('account')) {
                    this.week[this.day].account = { account: undefined, fringe: undefined, freeField: undefined, freeField2: undefined };
                }

                if (this.week[this.day].account.account === undefined && this.defaultAccount) {
                    this.week[this.day].account.account = this.defaultAccount;
                }

                if (this.week[this.day].account.fringe === undefined && this.defaultFringe) {
                    this.week[this.day].account.fringe = this.defaultFringe;
                }

                if (this.week[this.day].account.series === undefined && this.defaultSeries) {
                    this.week[this.day].account.series = this.defaultSeries;
                }

                if (this.week[this.day].account.location === undefined && this.defaultLocation) {
                    this.week[this.day].account.location = this.defaultLocation;
                }

                if (this.week[this.day].account.set === undefined && this.defaultSet) {
                    this.week[this.day].account.set = this.defaultSet;
                }

                if (this.week[this.day].account.freeField === undefined && this.defaultFreeField) {
                    this.week[this.day].account.freeField = this.defaultFreeField;
                }

                if (this.week[this.day].account.freeField2 === undefined && this.defaultFreeField2) {
                    this.week[this.day].account.freeField2 = this.defaultFreeField2;
                }
            }

            this.$emit('modified', true);
            return true;
        },

        locationCheck( {target} ) {
            if(target.value === 'addLocation') {
                this.locationModal = true;
                $("#addLocationForm input[name='name']").focus();
            } else if (! target) {
                return false;

            } else {
                this.week[this.day].location_id = target.value;
            }

            this.$emit('modified', true);
            return true;
        },

        // Obsolete?
        updateLocation( {target} ) {
            if (! target) {
                return false;
            }

            this.week[this.day].location = target.value
            return true;
        },

        updateUnionLocationDay(event) {
            if (!this.unionlocations || !Array.isArray(this.unionlocations)) return;
            const id = !isNaN(event) ? event : ((event || {}).target || {}).value;
            const match = this.unionlocations.find((loc) => parseInt(loc.id) === parseInt(id));
            if (id && match) {
                this.week[this.day].union_location_id = this.union_location_id = id;
                this.week[this.day].union_location = this.union_location = match.code;
            } else if (!id) {
                this.week[this.day].union_location_id = null;
                this.week[this.day].union_location = null;
            }
            return;
        },

        updateJobTitle( {target} ) {
            if (! target) {
                return false;
            }

            this.week[this.day].job_title_override = target.value;
            this.$emit('modified', true);
            return true;
        },

        updateRate( {target} ) { 
            // console.log(this.baserate);
            // console.log(isNaN(this.baserate.rate));
            let er_comments = (this.employer_comments) ? this.employer_comments + "\n" : '';

            if (! target) {
                return false;
            } else if (! isNaN(this.baserate.rate) && parseFloat(target.value) < parseFloat(this.baserate.rate)) {
                this.rate = this.week[this.day].rate = this.baserate.rate;
                this.employer_comments = this.week[this.day].employer_comments = er_comments + 'Reverted Rate to ' + this.rate + '.';
                alert ('The new rate cannot be less than the current rate.');
                return false;
            } else {
                this.rate = this.week[this.day].rate = target.value;
                this.employer_comments = this.week[this.day].employer_comments = er_comments + 'Changed Rate to ' + target.value + '.';
                this.$emit('modified', true);
                return true;
            }
        },

        updateEeComment( {target} ) {
            if (! target) {
                return false;
            }

            this.week[this.day].employee_comments = target.value
            this.$emit('modified', true);
            return true;
        },

        updateErComment( {target} ) {
            if (! target) {
                return false;
            }

            this.week[this.day].employer_comments = target.value 
            this.$emit('modified', true);
            return true;
        },

        clearDay() {
            // Still need to keep the main date
            this.$emit('modified', true);
            this.week[this.day] = { date: this.week[this.day].date };
            this.day_type = 'nowork';
            this.week[this.day].day_type = this.day_type;
            this.broken[this.day] = {};
            // Clear local variables
            this.time_1 = '';
            this.time_2 = '';
            this.time_3 = '';
            this.time_4 = '';
            this.time_5 = '';
            this.time_6 = '';
            this.time_7 = '';
            this.time_8 = '';
            this.time_9 = '';
            this.time_10 = '';
            this.time_11 = '';
            this.time_12 = '';
            this.location_id = this.mainlocation;
            this.job_title_override = this.titleor;
            this.rate = (this.baserate && ! isNaN(this.baserate.rate)) || '';
            this.rate_unit_id = '';
            this.employee_comments = '';
            this.employer_comments = '';

            this.timeErrors = {
                time_1: false,
                time_2: false,
                time_3: false,
                time_4: false,
                time_5: false,
                time_6: false,
                time_7: false,
                time_8: false,
                time_9: false,
                time_10: false,
                time_11: false,
                time_12: false,
            }
            return true;
        },

        loadDay(data) {
            if (data.assignment_id) {
                this.assignment = data.assignment;
                this.assignment_id = data.assignment_id;
            }

            if (data.location_id) {
                this.location = data.location;
                this.location_id = data.location_id;
            }
            // need to edit here when these fields are separated into 4 UI elements.
            if (data.union_ndb) this.selected_ndb_grace = 'ndb';
            if (data.union_grace) this.selected_ndb_grace = 'grace';
            if (data.union_ndm1) this.selected_ndb_grace = 'ndm1';
            
            if (data.union_walking_meal) this.selected_wm_wrap = 'wm';
            if (data.union_wrap) this.selected_wm_wrap = 'wrap';

            this.project_code = data.project;
            this.job_title_override = data.job_title_override || this.job_title_override;
            this.rate = data.rate || (this.baserate || {}).rate || this.rate;
            this.rate_unit_id = data.rate_unit_id || this.rate_unit_id;
            this.employee_comments = data.employee_comments || this.employee_comments;
            this.employer_comments = data.employer_comments || this.employer_comments;
            if (data.day_type) {
                // TODO Data repair, but for now, fix with hard coded values
                if (data.day_type.toLowerCase() === 'worked' || data.day_type.match(/^201.-/) ) {
                    this.day_type = 'worked';
                } else if (data.day_type.toLowerCase() === 'not worked') {
                    this.day_type = 'nowork';
                } else {
                    this.day_type = data.day_type;
                }
            } else {
                this.day_type = 'nowork';
            }
            if (data.time_1 || data.time_2 || data.time_3 || data.time_4 || data.time_5 || data.time_6) {
                this.loadTimes(data);
            }

            // Set account/free field line
            if (this.showAccountString) {
                if (typeof data.account === 'undefined') {
                    data.account = { account: undefined, fringe: undefined, freeField: undefined, freeField2: undefined };
                }

                if (data.account.account === undefined && this.defaultAccount) {
                    data.account.account = this.week[this.day].account.account = this.defaultAccount;
                }
                if (data.account.fringe === undefined && this.defaultFringe) {
                    data.account.fringe = this.week[this.day].account.fringe = this.defaultFringe;
                }

                if (data.account.series === undefined && this.defaultSeries) {
                    this.week[this.day].account.series = this.defaultSeries;
                }

                if (data.account.location === undefined && this.defaultLocation) {
                    this.week[this.day].account.location = this.defaultLocation;
                }

                if (data.account.set === undefined && this.defaultSet) {
                    this.week[this.day].account.set = this.defaultSet;
                }

                if (data.account.freeField === undefined && this.defaultFreeField) {
                    data.account.freeField = this.week[this.day].account.freeField = this.defaultFreeField;
                }

                if (data.account.freeField2 === undefined && this.defaultFreeField2) {
                    data.account.freeField2 = this.week[this.day].account.freeField2 = this.defaultFreeField2;
                }
            }
            return true;
        },

        loadTimes(data) {
            // set local time.
            let tempTime1 = '';
            let target = {}
            if (data.time_1) {
                tempTime1 = data.time_1;
                this.time_1 = data.time_1 ? this.shortenDate(data.time_1, null, data.date.full) : "";
                target.name = 'time_1'
                target.value = this.time_1;
                this.$refs.time1.verifyTime({target}, data.date.full, this.tzoffset, true)
            }
            if (data.time_2) {
                this.time_2 = data.time_2 ? this.shortenDate(data.time_2, tempTime1, data.date.full) : "";
                target.name = 'time_2'
                target.value = this.time_2
                this.$refs.time2.verifyTime({target}, data.date.full, this.tzoffset, true)
            }
            if (data.time_3) {
                this.time_3 = data.time_3 ? this.shortenDate(data.time_3, tempTime1, data.date.full) : "";
                target.name = 'time_3'
                target.value = this.time_3
                this.$refs.time3.verifyTime({target}, data.date.full, this.tzoffset, true)
            }
            if (data.time_4) {
                this.time_4 = data.time_4 ? this.shortenDate(data.time_4, tempTime1, data.date.full) : "";
                target.name = 'time_4'
                target.value = this.time_4
                this.$refs.time4.verifyTime({target}, data.date.full, this.tzoffset, true)
            }
            if (data.time_5) {
                this.time_5 = data.time_5 ? this.shortenDate(data.time_5, tempTime1, data.date.full) : "";
                target.name = 'time_5'
                target.value = this.time_5
                this.$refs.time5.verifyTime({target}, data.date.full, this.tzoffset, true)
            }
            if (data.time_6) {
                this.time_6 = data.time_6 ? this.shortenDate(data.time_6, tempTime1, data.date.full) : "";
                target.name = 'time_6'
                target.value = this.time_6
                this.$refs.time6.verifyTime({target}, data.date.full, this.tzoffset, true)
            }
            if (data.time_7) this.time_7 = data.time_7 ? this.shortenDate(data.time_7, data.time_1, data.date.full) : "";
            if (data.time_8) this.time_8 = data.time_8 ? this.shortenDate(data.time_8, data.time_1, data.date.full) : "";
            if (data.time_9) this.time_9 = data.time_9 ? this.shortenDate(data.time_9, data.time_1, data.date.full) : "";
            if (data.time_10) this.time_10 = data.time_10 ? this.shortenDate(data.time_10, data.time_1, data.date.full) : "";
            if (data.time_11) this.time_11 = data.time_11 ? this.shortenDate(data.time_11, data.time_1, data.date.full) : "";
            if (data.time_12) this.time_12 = data.time_12 ? this.shortenDate(data.time_12, data.time_1, data.date.full) : "";
        },
        // should get "YYYY-MM-DD" format
        compareTwoDates(date1, date2) {
            let date1Arr = date1.split('-');
            let date2Arr = date2.split('-');
            if (!date1Arr[0] || !date1Arr[1] || !date1Arr[2] || !date2Arr[0] || !date2Arr[1] || !date2Arr[2]) return false;

            let date1Num = Number(date1Arr[0] * 10000 + date1Arr[1] * 100 + date1Arr[2]);
            let date2Num = Number(date2Arr[0] * 10000 + date2Arr[1] * 100 + date2Arr[2]);

            return date1Num <= date2Num;
        },
        comparePhases(today, yesterday) {
            if (!today || !yesterday) return false;
            let todayType = false;
            let yesterdayType = false; 
            if (this.ppStartDay && this.ppEndDay) {
                let todayDate = new Date(today.date.full).toISOString().split('T')[0];
                if ( (this.compareTwoDates(this.ppStartDay,todayDate)) && (this.compareTwoDates(todayDate,this.ppEndDay)) ) {
                    todayType = true;
                }

                let yesterdayDate = new Date(yesterday.date.full).toISOString().split('T')[0];
                if ( (this.compareTwoDates(this.ppStartDay,yesterdayDate)) && (this.compareTwoDates(yesterdayDate,this.ppEndDay)) ) {
                    yesterdayType = true;
                }
            }
            if (this.wpStartDay && this.wpEndDay) {
                let todayDate = new Date(today.date.full).toISOString().split('T')[0];
                if ( (this.compareTwoDates(this.wpStartDay,todayDate)) && (this.compareTwoDates(todayDate,this.wpEndDay)) ) {
                    todayType = true;
                }
                let yesterdayDate = new Date(yesterday.date.full).toISOString().split('T')[0];
                if ( (this.compareTwoDates(this.wpStartDay,yesterdayDate)) && (this.compareTwoDates(yesterdayDate,this.wpEndDay)) ) {
                    yesterdayType = true;
                }
            }
            if (todayType != yesterdayType) return false;
            return true;
        },

        duplicateYesterday() {
            let yesterday = this.previousDay(this.day);
            let previousLastDay = this.previous_last_day ? this.previous_last_day : false;
            if ( ( yesterday && this.week[yesterday].time_1 ) || ( previousLastDay && previousLastDay.time_1 )) {
                // set yesterdays time to today...
                this.$emit('modified', true);
                let temp = JSON.parse(JSON.stringify(this.week[this.day]));

                if (previousLastDay) {
                    this.week[this.day] = JSON.parse(JSON.stringify(this.previous_last_day));
                }
                else {
                    this.week[this.day] = JSON.parse(JSON.stringify(this.week[yesterday]));
                }
                if (!this.comparePhases(temp,this.week[this.day])) {
                    if (temp.account) {
                        this.week[this.day].account = JSON.parse(JSON.stringify(temp.account));
                    } else {
                        this.week[this.day].account = {};
                    }
                    
                }

                // ... but be sure to update the date as we are dealing with full dates
                for (let index in this.week[this.day]) {
                    if (index === 'date') {
                        // Copy date
                        let date = new Date(this.week[this.day].date.full);
                        date = new Date(date.getTime() + 86400000); // set one day ahead
                        // we use dd/mm/yyyy for en-CA case. technically en-CA is yyyy/mm/dd, en-GB is dd/mm/yyyy
                        let tempLocale = this.locale === 'en-CA' ? 'en-GB' : this.locale;
                        let shortDate = date.toLocaleDateString(tempLocale, {
                            weekday: 'short',
                            day: '2-digit',
                            month: '2-digit',
                        });
                        this.week[this.day].date = { short: shortDate, full: date };
                    } else if (! index.match(/^time_[1-6]/)) {
                        // Don't process if not time related or date (above)
                        continue;
                    } else {
                        (this.week[this.day][index]) ? this.week[this.day][index] = new Date(new Date(this.week[this.day][index]).getTime() + 86400000) : '';
                    }
                }

                // Need to update our component data and make sure we add a day and send a shortened time to the screen
                if (this.week[this.day].day_type)
                    this.day_type = this.week[this.day].day_type;
                else {
                    this.week[this.day].day_type = 'worked';
                    this.day_type = 'worked';
                }

                this.project_code = this.week[this.day].project;
                this.location_id = this.week[this.day].location_id || this.mainlocation;
                this.job_title_override = this.week[this.day].job_title_override || this.job_title_override;
                this.rate = this.week[this.day].rate || this.rate;
                this.rate_unit_id = this.week[this.day].rate_unit_id;
                this.employee_comments = this.week[this.day].employee_comments;
                this.employer_comments = this.week[this.day].employer_comments;
                this.time_1 = this.shortenDate(this.week[this.day].time_1, null, this.week[this.day].date.full);
                this.time_2 = this.shortenDate(this.week[this.day].time_2, this.week[this.day].time_1, this.week[this.day].date.full);
                this.time_3 = this.shortenDate(this.week[this.day].time_3, this.week[this.day].time_1, this.week[this.day].date.full);
                this.time_4 = this.shortenDate(this.week[this.day].time_4, this.week[this.day].time_1, this.week[this.day].date.full);
                this.time_5 = this.shortenDate(this.week[this.day].time_5, this.week[this.day].time_1, this.week[this.day].date.full);
                this.time_6 = this.shortenDate(this.week[this.day].time_6, this.week[this.day].time_1, this.week[this.day].date.full);
                this.time_7 = this.shortenDate(this.week[this.day].time_7, this.week[this.day].time_1, this.week[this.day].date.full);
                this.time_8 = this.shortenDate(this.week[this.day].time_8, this.week[this.day].time_1, this.week[this.day].date.full);
                this.time_9 = this.shortenDate(this.week[this.day].time_9, this.week[this.day].time_1, this.week[this.day].date.full);
                this.time_10 = this.shortenDate(this.week[this.day].time_10, this.week[this.day].time_1, this.week[this.day].date.full);
                this.time_11 = this.shortenDate(this.week[this.day].time_11, this.week[this.day].time_1, this.week[this.day].date.full);
                this.time_12 = this.shortenDate(this.week[this.day].time_12, this.week[this.day].time_1, this.week[this.day].date.full);

                // The copied project may not be valid for this day's new date — either outside its
                // assigned window, or not an available assigned project at all. In either case, unset
                // the project + project_id and show an error. Only run when the project list is loaded.
                if (this.showAssignedProjects && this.week[this.day].project && Array.isArray(this.projects) && this.projects.length) {
                    let project = this.projects.find((p) => p.code == this.week[this.day].project);
                    let dayDate = new Date(this.week[this.day].date.full);
                    let projectError = '';
                    if (! project) {
                        projectError = 'The copied project is not assigned for this date and was removed. Please select a project.';
                    } else if (project.date_start && dayDate < new Date(project.date_start.replace(/-/g, '/'))) {
                        projectError = 'This project has not been assigned for this date.  Please use a different project or a date starting ' + project.date_start + ' or later.';
                    } else if (project.date_end && dayDate > new Date(project.date_end.replace(/-/g, '/'))) {
                        projectError = 'This project has not been assigned for this date.  Please use a different project or a date ending ' + project.date_end + ' or earlier.';
                    }
                    if (projectError) {
                        this.week[this.day].project = '';
                        this.week[this.day].project_id = '';
                        this.project_code = '';
                        this.$emit('error', projectError);
                    }
                }
            } else {
            }
        },

        // helper to figure out previous day
        previousDay(day) {
            let prevDay = '';
            if (day === 'day_1') {
                prevDay = false;
            } else {
                let today = day.substr(4);
                prevDay = today - 1;
                prevDay = 'day_' + prevDay;
            }

            return prevDay;
        },

        showUnionSchedule () {
            this.$emit('clicked', true);
        },
        closeDetails() {
            this.showDetails = false;
        }
    },
});
</script>
<style scoped>
    .padding-20p { padding: 20%; }
    .checkbox-skinny{ margin: 70% 0px 0px 40% }
    .checkbox-border{ border: 1px solid #cccccc; border-radius: 4px; height: 34px; }
</style>
